import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable }   from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Option } from '../shared/model/model.class';
import { AppService } from '../shared/service/AppService.class';
import {  Mortgage, DispoData, ApptCalendar } from './model/model.mortgage';
import { Callerid } from '../callerid/model/model.callerid';

@Injectable()
export class DialerService extends AppService<Mortgage>{
  constructor(protected http:HttpClient) {
    super(http);
    this.appmod="mortgage";
  }
  
  public getContact(type:string):Observable<Mortgage[]>{
    let tmp = this.appmod;
    this.appmod="custom/mortgage";   
    let data = this.getService(type);
    this.appmod=tmp;
    return data;
  }
  
  public getCBContact(type:string):Observable<any[]>{
    let tmp = this.appmod;
    this.appmod="custom/candidatelist";   
    let data = this.getService(type);
    this.appmod=tmp;
    return data;
  }

  public getCRMLabels(type:string):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/crmlabel";   
    let data = this.getService(type);
    this.appmod=tmp;
    return data;   
  }

  public getAllObjection(type:string):Observable<any>{
    let tmp=this.appmod;   
    this.appmod="custom/getdilerobjection";
    let data=super.getService(type);
    this.appmod=tmp;
    return data;
    
  }

  getScripts(type:string):Observable<any>
  { 
    let tmp = this.appmod;
    this.appmod="custom/getDialerPhoneScript";   
    let data = this.getService(type);
    this.appmod=tmp;
    return data;    
  }  
 
  public getAllContact(type:string):Observable<Mortgage[]>{
    let tmp = this.appmod;
    this.appmod="custom/allmortgage";   
    let data = this.getService(type);
    this.appmod=tmp;
    return data;
  }

  public searchMultipleContact(type:string):Observable<Mortgage[]>{
    let tmp = this.appmod;
    this.appmod="custom/searchcontactlist";   
    let data = this.getService(type);
    this.appmod=tmp;
    return data;
  }
  
  public getSingleContact(type:any):Observable<Mortgage[]>{
    let tmp = this.appmod;
    this.appmod="custom/singlecontact";   
    let data = this.getService(type);
    this.appmod=tmp;
    return data;
  }

  getBalance(type:string, filter:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="balance";   
    let data = this.getService(type, filter);
    this.appmod=tmp;
    return data;    
  }

  getCallerID(type:string):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/calleridrotetion";   
    let data = this.getService(type);
    this.appmod=tmp;
    return data;  
  }  

  getAllCallerID(type:string, filter:any):Observable<any>
  {
    return this.getService(type, filter);
  }  

  public saveSMS(sdata:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/savesms";   
    let data = this.saveService(sdata);
    this.appmod=tmp;
    return data;   
  }

  public saveDispoService(sdata:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/mortgage";   
    let data = this.saveService(sdata);
    this.appmod=tmp;
    return data;   
  }

  public saveVDService(sdata:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/savevdsms";   
    let data = this.saveService(sdata);
    this.appmod=tmp;
    return data;   
  }
  public saveEMService(sdata:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/saveemaildata";   
    let data = this.saveService(sdata);
    this.appmod=tmp;
    return data;   
  }

  public getCurrentDid():Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/currentdid";   
    let data = this.getService();
    this.appmod=tmp;
    return data;    
  }
  
  public savePref(sdata:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/changedialertype";   
    let data = this.custupdateService(sdata);
    this.appmod=tmp;
    return data;
  }

  public getPreferences(type:string, filter:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="setting";   
    let data = this.getService(type, filter);
    this.appmod=tmp;
    return data;   
  } 


  getOptionM(data:string,key:any):Observable<Option[]>{
    return this.getOption(data,key);
  }

  smstemplate(type:any)
  {
    let tmp = this.appmod;
    this.appmod="custom/getdialerSmsTemplate";   
    let auth = this.getService(type);
    this.appmod=tmp;
    return auth;  
  }
  getemailtempalte(type:any)
  {
    let tmp = this.appmod;
    this.appmod="custom/getdialerEmailTemplate";   
    let auth = this.getService(type);
    this.appmod=tmp;
    return auth; 
  }

  getvoicemailtemp(type:any)
  {
    let tmp = this.appmod;
    this.appmod="custom/getvoicemailtemp";   
    let auth = this.getService(type);
    this.appmod=tmp;
    return auth; 
  }

  leadUpdate(ldata:any, key:number):Observable<any>
  {    
    let tmp = this.appmod;
    this.appmod="custom/leadupdate";   
    let leaddata = this.updateService(ldata, key);
    this.appmod=tmp;
    return leaddata;
  } 

  getAuthToken():Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="agentauthtoken";   
    let auth = this.getService();
    this.appmod=tmp;
    return auth;   
  }

  public setObjection(sdata:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/setobjections";   
    let data = this.saveService(sdata);
    this.appmod=tmp;
    return data;   
  }
  
  public CallbackLeads(type:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/callbackleads";   
    let data = this.getService(type);
    this.appmod=tmp;
    return data;   
  }
  
  public getGlobalFilter(filter:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/globalfilter";   
    let data = this.getService("", filter);
    this.appmod=tmp;
    return data;   
  }

  public getFilterLeads(filter:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/getfilterleads";   
    let data = this.getService(filter);
    this.appmod=tmp;
    return data;   
  }

  public getAllSMSList():Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/getallsmslist";   
    let data = this.getService();
    this.appmod=tmp;
    return data;   
  }
 
  public UpdateView(date:any, key:number, type:string):Observable<any>{
    let tmp = this.appmod;
    this.appmod="smslist";   
    let resdata = this.updateService(date, null, type);
    this.appmod=tmp;
    return resdata;   
  }
  
  public getDisposition(type:string, filter:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="customdisposition";   
    let resdata = this.getService(type,filter);
    this.appmod=tmp;
    return resdata;   
  }
  
  public RemoveFilter(type:string):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/removefilter";   
    let resdata = this.getService(type);
    this.appmod=tmp;
    return resdata;   
  }
  
  public DeleteObjection(sdata:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/deleteobjections";   
    let data = this.saveService(sdata);
    this.appmod=tmp;
    return data;   
  }
  
  public GetZoomMeetingURL(sdata:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/createzoommeeting";   
    let data = this.saveService(sdata);
    this.appmod=tmp;
    return data;   
  }

  public updateemail(sdata:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/emailsmtp";   
    let data = this.saveService(sdata);
    this.appmod=tmp;
    return data;   
  }

  public saveLastcall(sdata:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/saveLastcall";   
    let data = this.saveService(sdata);
    this.appmod=tmp;
    return data;   
  }
  
  public smtpSetting_agent():Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/smtpSetting_agent";   
    let data = this.getService();
    this.appmod=tmp;
    return data;   
  }
    
}

@Injectable()
export class DispoDataService extends AppService<DispoData>{
  constructor(protected http:HttpClient) {
    super(http);
    this.appmod="";
   }

 public getScriptOption():Observable<any[]>
  {
    let tmp = this.appmod;
    this.appmod="scripts";   
    let data = this.getService();
    this.appmod=tmp;
    return data;   
  } 
}

// using for Calander  

@Injectable()
export class ApptCalendarService extends AppService<ApptCalendar>{
  constructor(protected http:HttpClient) {
    super(http);
    this.appmod="custom/agentgoogleevent";
  }

  public getScriptOption():Observable<any[]>
  {
    let tmp = this.appmod;
    this.appmod="scripts";   
    let data = this.getService();
    this.appmod=tmp;
    return data;    
  }

  getCalendarList():Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="calendarlist";   
    let data = this.getService();
    this.appmod=tmp;
    return data;
    
  }

  getAuthToken():Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="agentauthtoken";   
    let auth = this.getService();
    this.appmod=tmp;
    return auth;   
  }

  public converttimezone(sdata):Observable<any>
  {
    let tmp=this.appmod;
    this.appmod="custom/converttimezone";
    let data=this.saveService(sdata)
    this.appmod=tmp;
    return data;
  } 
}

@Injectable()
export class CampaignService extends AppService<Callerid>{
  constructor(protected http:HttpClient) {
    super(http);
    this.appmod="campaign";
   } 
}